<template>
    <div class="type-select">
        <el-tree
            v-if="isShow"
            ref="tree"
            node-key="id"
            empty-text="数据加载中"
            :data.sync="newData"
            :props.sync="props"
            :default-expanded-keys="[0]"
            @check="check"
            @current-change="currentChange"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
          <el-tooltip
                  class="item"
                  effect="light"
                  :content="node.label"
                  placement="top"
                  :open-delay="$enums.openDelay.low"
          >
            <span>{{ node.label }}</span>
          </el-tooltip>
<!--        <span-->
<!--            class="btns">-->
<!--            <img-->
<!--                class="add"-->
<!--                :src="$images.material.add"-->
<!--                alt="add"-->
<!--                @click.stop="() => append(data)"-->
<!--            />-->

<!--            <img-->
<!--                class="del"-->
<!--                :src="$images.material.shangchu"-->
<!--                alt="delete"-->
<!--                @click.stop="() => remove(node, data)"-->
<!--            />-->
<!--        </span>-->
      </span>
        </el-tree>
    </div>
</template>

<script>
    import * as CommonServer from "../../../../api/common";
    export default {
        name: "type-select",
        props: {
            categoryId: [String, Number],
            type: String,
            apiConfig: Object,
            data: [Array,Object],
            isShow: {
                type: Boolean,
                default: false
            }
        },
        created () {
            this.newData=[];
            this.init()
        },
        watch: {
            newData: {
                handler (vl) {
                    this.$emit('update:data', vl)
                },
                deep: true,
                immediate: true
            },
            categoryId(vl) {this.newId = vl;},
        },
        data(){
            return {
                select: '',
                props: {
                    children: 'childrens',
                    label: 'name'
                },
                newId:this.categoryId,
                newData: [
                    {
                        id: 0,
                        name: '所有分类',
                        delete: true,
                        childrens: []
                    }
                ],
                setData:[],
            }
        },
        methods: {
            init () {
                this.flashData(true)
            },
            async flashData (initial) {
                const res = await CommonServer.default[this.apiConfig.select]({
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: this.type
                })
                // 如果是游戏或工具，过滤 & 其他 也需要过滤
                let data = res.data
                switch (this.type) {
                    case 'game':
                        data = data.filter(v=>v.io_count>0)
                        break
                    case 'tools':
                        data = data.filter(v=>v.tools_count>0)
                        break
                    default:
                        data = data.filter(v=>v.res_count>0)
                }
                if(this.apiConfig.select=="getResourceCategoryShopTree" && this.categoryId){
                    this.searchData(data,this.categoryId);
                    data=this.setData;
                    //data=data.filter(v=>v.name==this.categoryId);
                    this.newData=data;
                    console.log("开始过滤非本类数组；",this.newData,data);
                }else{
                    this.newData=[
                        {
                            id: 0,
                            name: '所有分类',
                            delete: true,
                            childrens: []
                        }
                    ];
                    this.newData[0].childrens = data
                }
                console.log('分类树==>2', res,data)

                // 如果是初始化默认选择第一个分类
                if (initial) {
                    try {
                        if(this.apiConfig.select=="getResourceCategoryShopTree" && this.categoryId){
                            this.currentChange(data[0]);
                            // this.$emit('onTypeSelectTwo', data[0])
                        }else{
                            this.$emit('onTypeSelectOne', res.data[0])
                        }
                    } catch (e) {
                        console.log('获取第一个分类失败==>', e)
                    }
                }
            },
            searchData(data,id){
                let that=this;
                let newData=[];
                data.map(res=>{
                    if(res.name==id || res.id==id){
                        that.setData[0]=res;
                        return res;
                    }else{
                        if(res.childrens.length>0){
                            return that.searchData(res.childrens,id);
                        }
                    }
                })
                return newData;
            },
            currentChange (data, node) {
                console.log('node==>', data, node)
                // 如果是最后一个叶子节点 请求数据
                // if (`${data.id}` !== '0') {
                this.$emit('onTypeSelect', data, node)
                // }
            },
            onEditName (name) {
                this.editNode.label = name
            },
            handleEdit (node, data) {
                console.log(node, data)
                this.isEditShow = true
                this.editName = data.name
                this.editNode = data
            },
            check () {
                // 获取选中节点数组
                const arr = this.$refs.tree.getCheckedNodes()
                this.form.newValue = arr

                this.isClearVilidate()
            },
            async append (data) {
                const res = await CommonServer.default[this.apiConfig.add]({
                    clientsId: this.$store.state.selectSchoolId,
                    sort: this.type,
                    parentId: data.id,
                    name: '分类名'
                })
                console.log('添加', res)
                const newChild = {
                    id: res.data.id,
                    name: res.data.name
                }
                if (!data.childrens) {
                    this.$set(data, 'childrens', [])
                }
                data.childrens.push(newChild)
            },

            async remove (node, data) {
                const res = await CommonServer.default[this.apiConfig.delete]({
                    id: data.id,
                    clientsId: this.$store.state.selectSchoolId
                })
                console.log('分类名分类名=>2', res)
                if (`${res.status_code}` === '200') {
                    const parent = node.parent
                    const childrens = parent.data.childrens || parent.data
                    const index = childrens.findIndex(d => d.id === data.id)
                    childrens.splice(index, 1)
                }
            }
        }
    }
</script>

<style>
    .type-select .el-tree{width: 100%;}
</style>
<style lang="scss" scoped>
.type-select{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .btns{
        .add{
            width: 16px;
            height: 11px;
            margin-left: 30px;
        }
        .del{
            width: 13px;
            height: 12px;
            margin-left: 10px;
        }
    }
}
</style>
